import { Navigate, useLocation } from 'react-router-dom';

const LEGACY_PREFIX = '/v2';

const LegacyV2Redirect = () => {
  const { pathname, search, hash } = useLocation();
  const stripped = pathname.slice(LEGACY_PREFIX.length) || '/';

  return <Navigate to={`${stripped}${search}${hash}`} replace />;
};

export default LegacyV2Redirect;
